module.exports = __webpack_public_path__ + "static/img/bottom1.f54da96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom1.png
// module id = 0vEe
// module chunks = 25